import { Component } from '@angular/core';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import {
  DAIRYNEXT_WORKSPACE_ID,
  DAIRYNEXT_REPORT_IDS,
  SINGLE_PAGE_POWERBI_CONFIG,
} from 'src/app/shared/models/powerbi-config.model';

@Component({
  selector: 'app-co2-example-company',
  templateUrl: './co2-example-company.component.html',
  imports: [PowerbiReportComponent],
})
export class Co2ExampleCompanyComponent {
  public readonly workspaceId = DAIRYNEXT_WORKSPACE_ID;
  public readonly reportId = DAIRYNEXT_REPORT_IDS.CO2_EXAMPLE_COMPANY;
  public readonly baseEmbedConfig = SINGLE_PAGE_POWERBI_CONFIG;
}
